import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import {} from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './aidas-object-property.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const AidasObjectPropertyDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const aidasObjectPropertyEntity = useAppSelector(state => state.aidasObjectProperty.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="aidasObjectPropertyDetailsHeading">AidasObjectProperty</h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">ID</span>
          </dt>
          <dd>{aidasObjectPropertyEntity.id}</dd>


          <dt>
            <span id="value">Value</span>
          </dt>
          <dd>{aidasObjectPropertyEntity.value}</dd>
          <dt>Aidas Object</dt>
          <dd>{aidasObjectPropertyEntity.aidasObject ? aidasObjectPropertyEntity.aidasObject.name : ''}</dd>
          <dt>Aidas Properties</dt>
          <dd>{aidasObjectPropertyEntity.aidasProperties ? aidasObjectPropertyEntity.aidasProperties.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/aidas-object-property" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/aidas-object-property/${aidasObjectPropertyEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

export default AidasObjectPropertyDetail;
